export const WAITING_CLASS = "educator-home-page-waiting";
export const WAIT_SCOPE_SELECTOR = "[data-educator-home-skeleton-wait-scope]";

export function waitTarget(element) {
  return element.closest(WAIT_SCOPE_SELECTOR) ?? element;
}

export function setContentInert(element, inert) {
  const scope = element.closest(WAIT_SCOPE_SELECTOR);
  if (scope) {
    Array.from(scope.children).forEach((child) => {
      child.inert = inert;
    });
    return;
  }

  Array.from(element.children).forEach((child) => {
    child.inert = inert;
  });
}

export function beginSkeletonWait(element) {
  const target = waitTarget(element);

  target.classList.add(WAITING_CLASS);
  target.setAttribute("aria-busy", "true");
  setContentInert(element, true);
}

export function endSkeletonWait(element) {
  const target = waitTarget(element);

  target.classList.remove(WAITING_CLASS);
  setContentInert(element, false);
  target.setAttribute("aria-busy", "false");
}
